import { useState, useEffect, useRef } from "react";
import config from "../config";

const { API_BASE, UPLOADS_URL } = config;

async function fetchJSON(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status} – ${url}`);
  return res.json();
}

function ArrowIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="7" y1="17" x2="17" y2="7" />
      <polyline points="7 7 17 7 17 17" />
    </svg>
  );
}

const SLIDE_BADGE_ICONS = [
  "icon_01.svg",
  "icon_03.svg",
  "icon_02.svg",
  "icon_04.svg",
];

const SLIDE_BADGE_TEXT = [
  { num: "100% GUARANTEED", lines: ["Satisfaction", "Guaranteed Convinience"] },
  { num: "5 STAR RATING",   lines: ["Solutions for", "Comfort of your Home"] },
  { num: "24/7 AVAILABLE",  lines: ["Available", "Everytime for Emergencies"] },
  { num: "CALL SUPPORT ",   lines: ["Immediate", "Services, Quick Response"] },
];

const SPIN_SLIDES = [
  { text: "Technical Experts | Exceptional Services",  link: "/products"  },
  { text: "Flexible Scheduling | Timeous Solutions",   link: "/contact-us"   },
  { text: "Transparent Pricing | Affordable For All",  link: "/about-us"   },
  { text: "Practical Portfolio | Our Recent Works",    link: "/portfolio" },
];

function Slide({ slide, features, active, logo, spinText, spinLink, badgeIndex }) {
  const titleWords = (slide.title || "").trim().split(" ");
  const headingFirst = titleWords[0] || "";
  const headingRest = titleWords.slice(1).join(" ");

  const badge = SLIDE_BADGE_TEXT[badgeIndex] || SLIDE_BADGE_TEXT[0];
  const badgeIcon = SLIDE_BADGE_ICONS[badgeIndex] || SLIDE_BADGE_ICONS[0];

  return (
    <div className={`sl ${active ? "sl--active" : ""}`}>
      <div className="sl__col sl__col--text">

        {/* ── Text column decorations ── */}
        <div className="sl__text-deco-circle sl__text-deco-circle--lg" aria-hidden="true" />
        <div className="sl__text-deco-circle sl__text-deco-circle--md" aria-hidden="true" />
        <div className="sl__text-deco-circle sl__text-deco-circle--sm" aria-hidden="true" />
        <div className="sl__text-deco-arc" aria-hidden="true" />
        <div className="sl__text-deco-dots" aria-hidden="true" />
        <div className="sl__text-deco-line sl__text-deco-line--1" aria-hidden="true" />
        <div className="sl__text-deco-line sl__text-deco-line--2" aria-hidden="true" />
        <div className="sl__text-deco-dot-solid sl__text-deco-dot-solid--1" aria-hidden="true" />
        <div className="sl__text-deco-dot-solid sl__text-deco-dot-solid--2" aria-hidden="true" />
        <div className="sl__text-deco-dot-solid sl__text-deco-dot-solid--3" aria-hidden="true" />
        <div className="sl__text-deco-gradient" aria-hidden="true" />

        <div className="sl__content">
          <span className="sl__badge-pill">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
            </svg>
            {slide.brand_name || "VYBERTECH INSTALLERS"}
          </span>

          <h1 className="sl__heading">
            <span className="sl__heading-1">{headingFirst}</span>{" "}
            <span className="sl__heading-2">{headingRest}</span>
          </h1>

          {slide.subtitle && <p className="sl__desc">{slide.subtitle}</p>}

          <div className="sl__btns">
            {slide.button_text && (
              <a href={slide.button_link || "#"} className="sl__btn sl__btn--primary">
                {slide.button_text} <ArrowIcon />
              </a>
            )}
          </div>

          {features.length > 0 && (
            <div className="sl__features">
              {features.slice(0, 1).map((f) => (
                <span className="sl__feature" key={f.id}>
                  <img src={`${UPLOADS_URL}/svg-icons/check.svg`} alt="" aria-hidden="true" className="sl__feature-icon" />
                  {f.description}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="sl__col sl__col--media">
        <img
          src={`${UPLOADS_URL}/slideshow/${slide.image_filename}`}
          alt={slide.title || "Slide"}
          className="sl__img"
        />
        <div className="sl__deco-circle sl__deco-circle--lg" aria-hidden="true" />
        <div className="sl__deco-circle sl__deco-circle--sm" aria-hidden="true" />
        <div className="sl__deco-dots" aria-hidden="true" />
        <div className="sl__deco-dot-solid" aria-hidden="true" />

        {/* ── Rotating logo badge ── */}
        <a href={spinLink || "#"} className="sl__badge" aria-label={spinText}>
          <svg className="sl__spin-ring" viewBox="0 0 100 100">
            <defs>
              <path id={`spinTextPath-${slide.id}`} d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" />
            </defs>
            <text className="sl__spin-text">
              <textPath href={`#spinTextPath-${slide.id}`} startOffset="0%">
                {spinText} {"  |  "}
              </textPath>
            </text>
          </svg>
          {logo && (
            <img
              src={`${UPLOADS_URL}/logos/${logo.image_filename}`}
              alt={logo.alt_text || logo.title || "Logo"}
              className="sl__spin-logo"
            />
          )}
        </a>

        {/* ── Satisfaction badge ── */}
        <div className="sl__spin-badge">
          <img
            src={`${UPLOADS_URL}/svg-icons/${badgeIcon}`}
            alt=""
            aria-hidden="true"
            className="sl__spin-badge-icon"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
          <div className="sl__spin-badge-info">
            <div className="sl__spin-badge-stars" aria-hidden="true">★★★★★</div>
            <div className="sl__spin-badge-num">{badge.num}</div>
            <div className="sl__spin-badge-text">{badge.lines[0]} {badge.lines[1]}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Lightweight success modal ── */
function QuoteSuccessModal({ message, onClose }) {
  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <div className="qb-modal__backdrop" role="dialog" aria-modal="true" aria-labelledby="qb-modal-title" onClick={onClose}>
      <div className="qb-modal" onClick={(e) => e.stopPropagation()}>
        <div className="qb-modal__icon-wrap">
          <img
            src={`${UPLOADS_URL}/svg-icons/check.svg`}
            alt="Success"
            className="qb-modal__check-icon"
          />
        </div>
        <h3 id="qb-modal-title" className="qb-modal__title">Quote Request Received!</h3>
        <p className="qb-modal__msg">{message}</p>
        <button className="qb-modal__btn" onClick={onClose}>Done</button>
      </div>
    </div>
  );
}

/* ── Get-a-quote bar ── */
function QuoteBar({ services }) {
  const [form, setForm] = useState({ name: "", email: "", service: "", website: "" });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");
  const [statusMsg, setStatusMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setErrors({});
    setStatusMsg("");

    const selectedService = services.find((s) => String(s.id ?? s) === String(form.service));
    const serviceLabel = selectedService ? (selectedService.title || selectedService) : "";

    const payload = {
      name: form.name,
      email: form.email,
      subject: serviceLabel ? `Quote Request ${serviceLabel}` : "Quote Request",
      message: serviceLabel
        ? `Quick quote request from the homepage slider. Service of interest: ${serviceLabel}.`
        : "Quick quote request from the homepage slider.",
      website: form.website,
    };

    try {
      const res = await fetch(`${API_BASE}/contact-submit.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (res.ok && data.success) {
        const msg = data.email_sent
          ? "Thanks! We've received your quote request and will be in touch shortly."
          : "Thanks! We've saved your quote request and will be in touch shortly.";
        setStatus("idle");
        setForm({ name: "", email: "", service: "", website: "" });
        setSuccessMsg(msg);
      } else if (data.errors) {
        setErrors(data.errors);
        setStatus("error");
        setStatusMsg("Please fix the errors below.");
      } else {
        setStatus("error");
        setStatusMsg(data.message || "Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Quote bar submit error:", err);
      setStatus("error");
      setStatusMsg("Could not send your request. Please try again later.");
    }
  };

  const isSending = status === "sending";

  return (
    <>
      {successMsg && (
        <QuoteSuccessModal message={successMsg} onClose={() => setSuccessMsg(null)} />
      )}

      <form className="qb" onSubmit={handleSubmit} noValidate>
        <div className="qb__inner">
          {/* Honeypot */}
          <input
            type="text"
            name="website"
            value={form.website}
            onChange={handleChange}
            className="qb__honeypot"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
          />

          <label className="qb__field">
            <span className="qb__icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
              </svg>
            </span>
            <input
              type="text" name="name" placeholder="Your Name" className="qb__input"
              value={form.name} onChange={handleChange} disabled={isSending}
            />
          </label>

          <label className="qb__field">
            <span className="qb__icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 6l-10 7L2 6" />
              </svg>
            </span>
            <input
              type="email" name="email" placeholder="Email Address" className="qb__input"
              value={form.email} onChange={handleChange} disabled={isSending}
            />
          </label>

          <label className="qb__field qb__field--select">
            <span className="qb__icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 2 2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" />
              </svg>
            </span>
            <select
              className="qb__select" name="service"
              value={form.service} onChange={handleChange} disabled={isSending}
            >
              <option value="">Choose Service</option>
              {services.map((s) => (
                <option key={s.id || s} value={s.id || s}>{s.title || s}</option>
              ))}
            </select>
          </label>

          <button type="submit" className="qb__submit" disabled={isSending}>
            {isSending ? "SENDING..." : "BOOK NOW"} <ArrowIcon />
          </button>
        </div>

        {(errors.name || errors.email) && (
          <div className="qb__errors">
            {errors.name && <span className="qb__error">{errors.name}</span>}
            {errors.email && <span className="qb__error">{errors.email}</span>}
          </div>
        )}

        {statusMsg && status === "error" && !errors.name && !errors.email && (
          <div className="qb__status qb__status--error">{statusMsg}</div>
        )}
      </form>
    </>
  );
}

const SOCIAL_SVG = {
  Facebook: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/></svg>,
  Instagram: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"/></svg>,
  Tiktok: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0z"/></svg>,
  Whatsapp: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326z"/></svg>,
  Youtube: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/></svg>,
  Twitter: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/></svg>,
  Linkedin: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/></svg>,
};

function SocialIcon({ platform }) {
  const key = Object.keys(SOCIAL_SVG).find(k => k.toLowerCase() === (platform || "").toLowerCase());
  return key ? SOCIAL_SVG[key] : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8"/></svg>;
}

function Slideshow() {
  const [slides, setSlides] = useState([]);
  const [features, setFeatures] = useState([]);
  const [services, setServices] = useState([]);
  const [social, setSocial] = useState([]);
  const [logo, setLogo] = useState(null);
  const [active, setActive] = useState(0);
  const timerRef = useRef(null);

  const SLIDE_FOLLOW_COLORS = [
    "rgba(2,154,221,0.55)",
    "rgba(1,61,151,0.55)",
    "rgba(2,154,221,0.55)",
    "rgba(2,154,221,0.55)",
    "rgba(1,61,151,0.55)",
  ];

  useEffect(() => {
    fetchJSON(`${API_BASE}/slideshow.php`)
      .then((data) => {
        setSlides(Array.isArray(data?.slides) ? data.slides : []);
        setFeatures(Array.isArray(data?.features) ? data.features : []);
      })
      .catch((err) => console.error("Slideshow load error:", err));
    fetchJSON(`${API_BASE}/services.php`)
      .then((data) => {
        const groups = Array.isArray(data) ? data : [];
        const flat = groups.flatMap((g) => Array.isArray(g.services) ? g.services : []);
        setServices(flat);
      })
      .catch(() => {});
    fetchJSON(`${API_BASE}/social-links.php`).then((data) => setSocial(Array.isArray(data) ? data : [])).catch(() => {});
    fetchJSON(`${API_BASE}/logo.php`).then((data) => setLogo(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (slides.length < 2) return;
    timerRef.current = setInterval(() => setActive((a) => (a + 1) % slides.length), 12000);
    return () => clearInterval(timerRef.current);
  }, [slides.length]);

  const goTo = (i) => { setActive(i); if (timerRef.current) clearInterval(timerRef.current); };
  const [followOpen, setFollowOpen] = useState(false);

  if (!slides.length) return null;

  const followColor = SLIDE_FOLLOW_COLORS[active % SLIDE_FOLLOW_COLORS.length];

  return (
    <section className="ss">
      <div className="ss__slides-clip">
        <div className="ss__slides">
          {slides.map((slide, i) => (
            <Slide
              key={slide.id}
              slide={slide}
              features={features}
              active={i === active}
              logo={logo}
              spinText={(SPIN_SLIDES[i] || SPIN_SLIDES[0]).text}
              spinLink={(SPIN_SLIDES[i] || SPIN_SLIDES[0]).link}
              badgeIndex={i}
            />
          ))}
        </div>

        {social.length > 0 && (
          <div className={`ss__follow ${followOpen ? "ss__follow--open" : ""}`} style={{ background: followColor }}>
            <button className="ss__follow-toggle" onClick={() => setFollowOpen(v => !v)}
              aria-label={followOpen ? "Hide social links" : "Show social links"} style={{ background: followColor }}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                <path d={followOpen ? "M8 2L4 6l4 4" : "M4 2l4 4-4 4"} stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <span className="ss__follow-label">FOLLOW US</span>
            <div className="ss__follow-icons">
              {social.slice(0, 5).map((s) => (
                <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer"
                  className="ss__follow-icon" aria-label={s.platform}>
                  <SocialIcon platform={s.platform} />
                </a>
              ))}
            </div>
          </div>
        )}

        {slides.length > 1 && (
          <div className="ss__dots" role="tablist" aria-label="Slide navigation">
            <span className="ss__dots-count">
              <span className="ss__dots-count-active">{String(active + 1).padStart(2, "0")}</span>
              <span className="ss__dots-count-sep" aria-hidden="true" />
              <span className="ss__dots-count-total">{String(slides.length).padStart(2, "0")}</span>
            </span>
            <div className="ss__dots-lines">
              {slides.map((s, i) => (
                <button key={s.id} className={`ss__dot ${i === active ? "ss__dot--active" : ""}`}
                  onClick={() => goTo(i)} aria-label={`Go to slide ${i + 1}`} aria-selected={i === active} role="tab" />
              ))}
            </div>
          </div>
        )}
      </div>

      <QuoteBar services={services} />

      <style>{`
  .ss{position:relative;width:100%;background:#f4f6fb;overflow:visible;padding-bottom:0}

  .ss__slides-clip{
    position:relative;
    width:100%;
    min-height:580px;
    overflow:hidden;
    padding-bottom:42px;
  }

  .ss__slides{position:absolute;top:0;left:0;right:0;bottom:0;width:100%}

  .sl{
    position:absolute;inset:0;
    opacity:0;visibility:hidden;
    transition:opacity .6s ease;
    display:grid;grid-template-columns:1fr 1fr;
    align-items:stretch;
    width:100%;height:100%;
  }

  .sl--active{
    opacity:1;visibility:visible;
  }

  .sl__col--text{
    position:relative;z-index:3;padding:40px 5% 90px 6%;
    display:flex;flex-direction:column;justify-content:center;gap:14px;
    height:100%;text-align:justify;
    overflow:hidden;
    background:linear-gradient(135deg, #eaf4fb 0%, #f4f6fb 50%, #eaf0fa 100%);
  }

  /* ── Text column decorations ── */
  .sl__text-deco-gradient{
    position:absolute;inset:0;pointer-events:none;z-index:0;
    background:
      radial-gradient(ellipse 70% 60% at 100% 0%, rgba(255,140,0,0.14) 0%, transparent 70%),
      radial-gradient(ellipse 55% 50% at 100% 100%, rgba(2,154,221,0.10) 0%, transparent 70%),
      radial-gradient(ellipse 50% 60% at 90% 50%, rgba(255,140,0,0.10) 0%, transparent 70%);
  }
  .sl__text-deco-circle{
    position:absolute;border-radius:50%;pointer-events:none;z-index:0;
  }
  .sl__text-deco-circle--lg{
    width:420px;height:420px;
    top:-160px;right:-160px;
    border:1.5px solid rgba(255,140,0,0.18);
  }
  .sl__text-deco-circle--md{
    width:260px;height:260px;
    bottom:-100px;left:-80px;
    border:1.5px solid rgba(1,61,151,0.12);
    background:radial-gradient(circle, rgba(2,154,221,0.05) 0%, transparent 70%);
  }
  .sl__text-deco-circle--sm{
    width:160px;height:160px;
    top:50%;
    right:-20px;
    transform:translateY(-50%);
    left:auto;
    border:1px solid rgba(255,140,0,0.22);
    background:radial-gradient(circle, rgba(255,140,0,0.10) 0%, transparent 70%);
  }
  .sl__text-deco-arc{
    position:absolute;pointer-events:none;z-index:0;
    width:360px;height:360px;
    bottom:-160px;right:-60px;
    border-radius:50%;
    border:1px solid rgba(255,140,0,0.14);
    border-top-color:transparent;
    border-right-color:transparent;
  }
  .sl__text-deco-dots{
    position:absolute;top:0;right:0;width:180px;height:160px;z-index:0;pointer-events:none;
    background-image:radial-gradient(rgba(2,154,221,0.25) 1.5px, transparent 1.6px);
    background-size:14px 14px;
    -webkit-mask-image:linear-gradient(315deg, black 10%, transparent 75%);
    mask-image:linear-gradient(315deg, black 10%, transparent 75%);
  }
  .sl__text-deco-line{
    position:absolute;pointer-events:none;z-index:0;
    background:linear-gradient(90deg, transparent, rgba(2,154,221,0.18), transparent);
    height:1px;
  }
  .sl__text-deco-line--1{width:70%;bottom:28%;left:0}
  .sl__text-deco-line--2{
    width:40%;top:22%;left:0;
    background:linear-gradient(90deg, transparent, rgba(1,61,151,0.13), transparent);
  }
  .sl__text-deco-dot-solid{
    position:absolute;border-radius:50%;pointer-events:none;z-index:0;
  }
  .sl__text-deco-dot-solid--1{width:10px;height:10px;background:#ff8c00;opacity:.4;top:18%;right:8%}
  .sl__text-deco-dot-solid--2{width:6px;height:6px;background:#013d97;opacity:.3;bottom:22%;right:6%}
  .sl__text-deco-dot-solid--3{width:14px;height:14px;background:#ff8c00;opacity:.25;bottom:14%;left:10%}

  .sl__col--text > .sl__content{
    position:relative; z-index:1;
    display:flex; flex-direction:column; gap:14px;
    max-width:640px;
  }

  .sl__badge-pill{display:inline-flex;align-items:center;gap:10px;align-self:flex-start;
    background:#e6f4fc;color:#029add;font-size:12.5px;font-weight:700;
    letter-spacing:.12em;text-transform:uppercase;padding:9px 18px;border-radius:999px}

  .sl__heading{font-size:46px;line-height:1.18;font-weight:800;letter-spacing:-1px;text-align:left}
  .sl__heading-1{color:#013d97}
  .sl__heading-2{color:#029add}
  .sl__desc{font-size:16px;line-height:1.8;color:#424244;max-width:480px}
  .sl__btns{display:flex;gap:14px;flex-wrap:wrap;text-align:left}

  .sl__btn{
    display:inline-flex;align-items:center;gap:8px;
    padding:15px 28px;
    border-radius:4px;
    font-size:14.5px;font-weight:700;font-family:'Roboto',sans-serif;
    white-space:nowrap;
    transition:background .2s,transform .15s,color .2s,box-shadow .2s;
  }
  .sl__btn--primary{
    background:#fff;
    color:#013045;
    box-shadow:0 6px 24px rgba(1,48,69,.22), 0 2px 8px rgba(1,48,69,.14);
  }
  .sl__btn--primary:hover{
    background:#f0f8ff;
    box-shadow:0 10px 32px rgba(1,48,69,.30), 0 3px 10px rgba(1,48,69,.18);
    transform:translateY(-2px);
  }

  .sl__features{display:flex;gap:28px;flex-wrap:wrap;margin-top:6px}
  .sl__feature{
    display:flex;align-items:center;gap:8px;
    font-size:16px;
    font-weight:600;
    color:#013d97;
    line-height:1.5;
  }
  .sl__feature-icon{width:22px;height:22px;flex-shrink:0;object-fit:contain}

  .sl__col--media{
    position:relative;z-index:4;
    height:100%;width:100%;
    overflow:visible;
    background:#e6f4fc;
  }
  .sl__img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center}

  .sl__deco-circle{position:absolute;border-radius:50%;border:1px solid rgba(255,255,255,.5);z-index:2;pointer-events:none}
  .sl__deco-circle--lg{width:480px;height:480px;top:-120px;left:-140px;border-color:rgba(255,255,255,.35)}
  .sl__deco-circle--sm{width:240px;height:240px;bottom:-80px;right:-60px;background:#cce8f7;border:none;opacity:.6}
  .sl__deco-dots{position:absolute;top:0;left:0;width:240px;height:200px;z-index:2;
    background-image:radial-gradient(#029add 1.5px, transparent 1.6px);background-size:14px 14px;opacity:.25;
    -webkit-mask-image:linear-gradient(225deg, transparent 30%, black 100%);
    mask-image:linear-gradient(225deg, transparent 30%, black 100%)}
  .sl__deco-dot-solid{position:absolute;bottom:24px;left:24px;width:20px;height:20px;border-radius:50%;background:#029add;z-index:2}

  .sl__badge{
    position:absolute;z-index:6;
    top:50%;left:-75px;
    transform:translateY(-50%);
    width:150px;height:150px;
    border-radius:50%;
    display:flex;align-items:center;justify-content:center;
    filter:drop-shadow(0 8px 20px rgba(1,61,151,.35));
    cursor:pointer;text-decoration:none;
  }
  .sl__badge::before{
    content:"";position:absolute;inset:0;
    border-radius:50%;
    background:linear-gradient(135deg,#d4af37 0%,#424244 100%);
  }

  .sl__spin-ring{position:absolute;inset:0;width:100%;height:100%;animation:sl-spin 18s linear infinite}
  .sl__spin-text{font-size:9px;font-weight:700;letter-spacing:1px;fill:#fff;text-transform:uppercase;font-family:'Roboto',sans-serif}
  .sl__spin-logo{position:relative;z-index:1;width:98px;height:98px;object-fit:contain;border-radius:50%;background:#fff;padding:0}
  @keyframes sl-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}

  .sl__spin-badge{
    position:absolute;z-index:4;
    top:50%;left:50%;
    transform:translate(-50%,-50%);
    width:auto;max-width:310px;
    background:rgba(2,154,221,0.78);
    backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);
    color:#fff;border-radius:14px;padding:16px 22px;
    display:inline-flex;flex-direction:row;align-items:center;gap:16px;
    box-shadow:0 18px 40px rgba(2,154,221,.25);
    transition:opacity .4s ease;white-space:nowrap;
  }
  .sl__spin-badge-icon{width:40px;height:40px;flex:0 0 40px;object-fit:contain;filter:brightness(0) invert(1);}
  .sl__spin-badge-info{display:flex;flex-direction:column;align-items:flex-start;text-align:left;gap:3px;}
  .sl__spin-badge-stars{font-size:12px;letter-spacing:2px;color:#fff}
  .sl__spin-badge-num{font-size:24px;font-weight:800;line-height:1.1;white-space:nowrap}
  .sl__spin-badge-text{font-size:11.5px;font-weight:600;line-height:1.3;white-space:nowrap}

  .ss__follow{position:absolute;top:0;right:0;width:52px;height:100%;z-index:10;
    display:flex;flex-direction:column;align-items:center;justify-content:center;gap:20px;
    transition:background .6s ease,transform .3s ease}
  .ss__follow-toggle{display:none;position:absolute;left:-22px;top:50%;transform:translateY(-50%);
    width:22px;height:44px;border:none;border-radius:6px 0 0 6px;cursor:pointer;
    align-items:center;justify-content:center;z-index:11}
  .ss__follow-label{writing-mode:vertical-rl;transform:rotate(180deg);font-size:11px;font-weight:700;
    letter-spacing:.18em;text-transform:uppercase;color:#fff;white-space:nowrap;margin-bottom:8px}
  .ss__follow-icons{display:flex;flex-direction:column;align-items:center;gap:16px}
  .ss__follow-icon{color:#fff;opacity:.85;display:flex;align-items:center;justify-content:center;transition:opacity .2s,transform .2s}
  .ss__follow-icon:hover{opacity:1;transform:scale(1.2)}

  .ss__dots{
    position:absolute;bottom:78px;left:24px;right:76px;z-index:8;
    display:flex;align-items:center;justify-content:space-between;gap:24px;
    pointer-events:none;
  }
  .ss__dots-count{
    display:flex;align-items:center;gap:10px;
    font-family:'Roboto',sans-serif;font-weight:800;
    color:#fff;text-shadow:0 1px 6px rgba(0,0,0,.25);
    pointer-events:auto;
  }
  .ss__dots-count-active{font-size:22px;color:#ff8c00;letter-spacing:.02em}
  .ss__dots-count-sep{display:inline-block;width:22px;height:1px;background:rgba(255,255,255,.6)}
  .ss__dots-count-total{font-size:13px;color:rgba(255,255,255,.75);font-weight:700}

  .ss__dots-lines{display:flex;align-items:center;gap:10px;pointer-events:auto}
  .ss__dot{
    width:34px;height:3px;border-radius:2px;border:none;
    background:rgba(255,255,255,.35);cursor:pointer;
    transition:background .25s,width .25s;padding:0;
  }
  .ss__dot--active{background:#ff8c00;width:48px}

  /* ── Quote bar: desktop ── */
  .qb{position:relative;z-index:20;display:flex;justify-content:center;padding:0 28px;transform:translateY(-50%);margin-bottom:-62px}
  .qb__inner{width:100%;max-width:1100px;background:#fff;border-radius:14px;
    box-shadow:0 18px 50px rgba(1,61,151,.18);display:flex;align-items:stretch;padding:14px;gap:14px;flex-wrap:wrap}
  .qb__field{flex:1;min-width:180px;display:flex;align-items:center;gap:10px;border:1px solid #e7e9f2;border-radius:10px;padding:0 16px;height:54px}
  .qb__icon{color:#029add;display:flex;align-items:center;flex-shrink:0}
  .qb__input,.qb__select{border:none;outline:none;font-size:14px;font-family:'Roboto',sans-serif;color:#013d97;width:100%;height:100%;background:transparent;appearance:none}
  .qb__input::placeholder{color:#9aa3bd}
  .qb__input:disabled,.qb__select:disabled{opacity:.6;cursor:not-allowed}
  .qb__field--select{position:relative}
  .qb__select{cursor:pointer}
  .qb__select:invalid,.qb__select option[value=""]{color:#9aa3bd}
  .qb__submit{flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;gap:8px;
    background:#029add;color:#fff;border:none;border-radius:10px;padding:0 32px;height:54px;
    font-size:14.5px;font-weight:700;font-family:'Roboto',sans-serif;cursor:pointer;
    transition:background .2s,transform .15s;white-space:nowrap}
  .qb__submit:hover:not(:disabled){background:#0180b8;transform:translateY(-1px)}
  .qb__submit:disabled{opacity:.65;cursor:not-allowed;transform:none}
  .qb__honeypot{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}
  .qb__errors{display:flex;gap:16px;flex-wrap:wrap;width:100%;max-width:1100px;margin:8px auto 0;padding:0 4px}
  .qb__error{font-size:12.5px;font-weight:600;color:#e0473e}
  .qb__status{width:100%;max-width:1100px;margin:8px auto 0;padding:10px 16px;border-radius:8px;font-size:13px;font-weight:600}
  .qb__status--error{background:#fdeceb;color:#c43d33}

  /* ── Quote success modal ── */
  .qb-modal__backdrop{
    position:fixed;inset:0;z-index:9999;
    background:rgba(1,21,70,.65);
    display:flex;align-items:center;justify-content:center;padding:24px;
    animation:qb-fade-in .2s ease;
  }
  @keyframes qb-fade-in{from{opacity:0}to{opacity:1}}
  .qb-modal{
    background:#fff;border-radius:16px;padding:44px 36px 36px;max-width:420px;width:100%;
    text-align:center;box-shadow:0 30px 80px rgba(0,0,0,.22);
    animation:qb-modal-in .25s cubic-bezier(.34,1.56,.64,1);
  }
  @keyframes qb-modal-in{from{opacity:0;transform:scale(.88) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  .qb-modal__icon-wrap{
    width:72px;height:72px;border-radius:50%;background:#1a8a4c;
    display:flex;align-items:center;justify-content:center;margin:0 auto 22px;
    box-shadow:0 12px 32px rgba(26,138,76,.3);
  }
  .qb-modal__check-icon{width:40px;height:40px;object-fit:contain;filter:brightness(0) invert(1)}
  .qb-modal__title{font-family:'Roboto',sans-serif;font-size:22px;font-weight:900;color:#1a1a2e;margin-bottom:12px}
  .qb-modal__msg{font-family:'Roboto',sans-serif;font-size:14.5px;color:#5a5f72;line-height:1.75;margin-bottom:28px}
  .qb-modal__btn{
    display:inline-flex;align-items:center;justify-content:center;
    background:#e96c29;color:#fff;border:none;cursor:pointer;
    font-family:'Roboto',sans-serif;font-size:14px;font-weight:800;letter-spacing:.04em;
    padding:13px 40px;border-radius:3px;transition:background .2s,transform .2s;
  }
  .qb-modal__btn:hover{background:#c85a1f;transform:translateY(-2px)}

  @media(max-width:900px){
    .ss__slides-clip{min-height:420px;padding-bottom:0}

    /* ── Hide the quote bar entirely on small screens ── */
    .qb{display:none}

    .sl{display:block;position:absolute;inset:0;}

    .sl__col--media{position:absolute;inset:0;z-index:1;}
    .sl__img{width:100%;height:100%;object-fit:cover;object-position:center top;}

    .sl__col--text{
      position:absolute;inset:0;z-index:3;height:100%;width:100%;
      background:linear-gradient(
        to bottom,
        rgba(0,0,0,0) 0%,rgba(0,0,0,0.25) 35%,rgba(0,20,60,0.82) 70%,rgba(0,20,60,0.95) 100%
      );
      display:flex;flex-direction:column;justify-content:flex-end;
      padding:72px 20px 72px;gap:10px;overflow:hidden;text-align:left;
    }

    .sl__col--text > .sl__content{max-width:100%;}

    .sl__heading{font-size:26px;letter-spacing:-.5px}
    .sl__heading-1{color:#fff}
    .sl__heading-2{color:#fff}
    .sl__desc{font-size:13.5px;color:#fff}
    .sl__badge-pill{font-size:10.5px;padding:6px 12px;gap:6px;background:rgba(255,255,255,0.18);color:#fff;}

    .sl__btn{padding:11px 20px;font-size:13px;}
    .sl__btn--primary{
      background:#fff;color:#013045;
      box-shadow:0 4px 16px rgba(1,48,69,.25);
    }

    .sl__feature{font-size:14px;color:#fff;}
    .sl__feature-icon{width:20px;height:20px;}

    .sl__badge{display:none}
    .sl__spin-badge{display:none}
    .sl__text-deco-circle,.sl__text-deco-arc,.sl__text-deco-dots,
    .sl__text-deco-line,.sl__text-deco-dot-solid,.sl__text-deco-gradient{display:none}

    .ss__follow{transform:translateX(100%);transition:transform .3s ease,background .6s ease}
    .ss__follow--open{transform:translateX(0)}
    .ss__follow-toggle{display:flex}

    .ss__dots{bottom:16px;left:16px;right:16px}
    .ss__dots-count-active{font-size:18px}
    .ss__dot{width:24px;height:3px}
    .ss__dot--active{width:34px}
  }

  @media(max-width:560px){
    .ss__slides-clip{min-height:340px}
    .sl__heading{font-size:21px}
    .sl__col--text{padding:0 16px 68px}
    .qb-modal{padding:36px 24px 28px}
    .qb-modal__title{font-size:19px}
  }
`}</style>
    </section>
  );
}

export default Slideshow;